import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  loaded: false,
  loading: false,
  hasAccepted: null,
};

const userTermsAndConditionsSlice = createSlice({
  name: 'userTermsAndConditions',
  initialState,
  reducers: {
    setUserTermsAndConditionsRequested: (state) => {
      return {
        ...state,
        hasAccepted: null,
        loaded: false,
        loading: true,
      };
    },
    setUserTermsAndConditionsReceived: (state, action) => {
      return {
        ...state,
        hasAccepted: action.payload,
        loaded: true,
        loading: false,
      };
    },
  },
});

// Actions
export const {
  setUserTermsAndConditionsRequested,
  setUserTermsAndConditionsReceived,
} = userTermsAndConditionsSlice.actions;

// Selectors
export const getUserTermsAndConditionsLoaded = (state) =>
  state.userTermsAndConditions.loaded;
export const getUserTermsAndConditionsLoading = (state) =>
  state.userTermsAndConditions.loading;
export const getUserTermsAndConditionsHasAccepted = (state) =>
  state.userTermsAndConditions.hasAccepted;

export default userTermsAndConditionsSlice.reducer;
